import Z from './zuora';
import * as reactApp from 'reactApp';

export default function (app) {
  app.factory('klPaymentService', [
    '$rootScope',
    '$http',
    '$q',
    'klTranslationService',
    'klNotificationService',
    'klAccountService',
    function ($rootScope, $http, $q, TranslationService, NotificationService, AccountService) {
      let _paymentPageParams;
      let _paymentDeferred;
      let _paymentMethodType;
      let _paymentMethodId;
      let _paymentMethod;

      const setInitialData = () =>
        AccountService.fetchAccount().then((account) => {
          _paymentMethodType = reactApp.getPaymentMethodType(account.paymentMethod);
          _paymentMethod = account.paymentMethod;
          _paymentMethodId = account.paymentMethod && account.paymentMethod.Id;
        });
      function getCurrency() {
        return AccountService.getCurrency();
      }

      function initPaymentMethod(paymentMethodType) {
        if (!paymentMethodType) {
          console.warn('paymentMethodType not set');
          return $q(function (rejectInit) {});
        }
        _paymentMethodType = paymentMethodType;

        if (_paymentMethodType === 'paypal') {
          return $q.when();
        }

        if (_paymentMethodType === 'invoice') {
          return $q.when();
        }
        if (_paymentMethodType == 'sepa' && !(AccountService.getCurrency() === 'EUR')) {
          return $q(function (rejectInit) {
            rejectInit("Sorry, your account currency doesn't allow SEPA payments.");
          });
        }

        return $q(function (resolveInit, rejectInit) {
          $http
            .get(`/api/payment-method/signature/${_paymentMethodType}`, {
              params: { locale: TranslationService.getLanguage() },
            })
            .then((response) => {
              _paymentPageParams = mergeObjects({}, response.data, {
                field_currency: AccountService.getCurrency(),
              });
              Z.runAfterRender(() => resolveInit());
              const prepopulate = {};
              Z.renderWithErrorHandler(
                _paymentPageParams,
                prepopulate,
                (response) => {
                  if (_paymentDeferred) {
                    if (response.statusText == 'OK' || response.success) {
                      _paymentMethodId = response.refId;
                      _paymentDeferred.resolve(_paymentMethodId);
                    } else {
                      _paymentDeferred.reject('Payment Deferred');
                    }
                  }
                },
                (key, code, message) => {
                  //NotificationService.putError('auth', error.message);
                  if (!!key && !!message) {
                    if (key !== 'error') {
                      Z.sendErrorMessageToHpm(key, message);
                    }
                  }
                  if (!!_paymentDeferred && message) {
                    _paymentDeferred.reject(message);
                  }
                },
              );
            })
            .catch(function (error) {
              console.error(error);
              const errorMessage = 'error_payment_method_init';
              NotificationService.putError('auth', errorMessage);
              if (rejectInit) {
                rejectInit(errorMessage);
              }
            });
        });
      }

      function fetchPaymentMethod(paymentMethodId) {
        let route = '/api/payment-method';
        if (paymentMethodId) {
          route = route + '/' + paymentMethodId;
        }
        return setInitialData().then(() =>
          $http.get(route).then(function (response) {
            setPaymentMethod(response.data);
            return _paymentMethod;
          }),
        );
      }

      function isReseller() {
        return AccountService.isReseller();
      }

      function submitPaymentMethod(origin) {
        _paymentDeferred = $q.defer();
        if (_paymentMethodType == 'invoice') {
          _paymentMethodId = null;
          const paymentMethod = {
            Type: 'BankTransfer',
          };
          setPaymentMethod(paymentMethod);
          return $q.when(paymentMethod);
        }
        if (_paymentMethodType == 'paypal') {
          _paymentMethodId = null;
          const paymentMethod = {
            Type: 'PayPal',
          };
          setPaymentMethod(paymentMethod);
          return initPaypal(origin);
        }
        try {
          if (!Z.submit()) {
            throw 'An error occurred.';
          }
        } catch (err) {
          const errorMessage = err.message;
          //if(!isset(errorMessage)) errorMessage = "Please correct your payment information.";
          //NotificationService.putError('auth', errorMessage);
          _paymentDeferred.reject(errorMessage);
        }
        return _paymentDeferred.promise.then(fetchPaymentMethod);
      }

      function initPaypal(origin) {
        return $http
          .get('/api/paypal/init', { params: { origin } })
          .then((response) => setPaymentMethod({ Type: 'PayPal', paypal: response.data }));
      }

      function getPaymentPageParams() {
        return _paymentPageParams;
      }

      function getPaymentMethodType() {
        return _paymentMethodType;
      }

      function getPaymentMethod() {
        return _paymentMethod;
      }

      function setPaymentMethod(paymentMethod) {
        _paymentMethod = paymentMethod;
        if (paymentMethod) {
          _paymentMethodId = paymentMethod.Id;
          _paymentMethodType = reactApp.getPaymentMethodType(paymentMethod);
        }
        return paymentMethod;
      }

      function getPaymentMethodId() {
        return _paymentMethodId;
      }

      function updatePaymentMethod(paymentMethod) {
        return AccountService.fetchAccount()
          .then((account) =>
            $http.put('/api/account/payment-method', {
              paymentMethod: paymentMethod,
              country: account.billToContact.country,
            }),
          )
          .then((response) => {
            reactApp.setLastPaymentProviderUpdate();
            return response;
          });
      }
      function mergeObjects() {
        var resObj = {};
        for (var i = 0; i < arguments.length; i += 1) {
          var obj = arguments[i],
            keys = Object.keys(obj);
          for (var j = 0; j < keys.length; j += 1) {
            resObj[keys[j]] = obj[keys[j]];
          }
        }
        return resObj;
      }

      return {
        getCurrency,
        initPaymentMethod,
        getPaymentMethod,
        setPaymentMethod,
        getPaymentMethodType,
        getPaymentPageParams,
        getPaymentMethodId,
        submitPaymentMethod,
        fetchPaymentMethod,
        updatePaymentMethod,
        isReseller,
      };
    },
  ]);
}
